// components/AppLoader.tsx
import { Box, CircularProgress, Typography } from '@mui/material';

export function AppLoader() {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
      }}
    >
      <CircularProgress />
      <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
        Loading…
      </Typography>
    </Box>
  );
}
